import React from 'react';
import { valueConverter } from '../../util-functions/util-funtions';
import './targetTracker.styles.scss';

const TargetYTDBrandTable = ({
    tableData
}) => {

    return (
        <table className='target-tracker-table'>
            <thead>
                <tr>
                    <th className='tt-table-header tt-table-cell' colSpan='6' style={{ textAlign: 'left' }}>Total Spent</th>
                    <th className='tt-table-header tt-table-cell' colSpan='2'>Spend (%)</th>
                    <th className='tt-table-header tt-table-cell' >Creep</th>
                    <th className='tt-table-header tt-table-cell'></th>
                </tr>
                <tr>
                    <th className='tt-table-header tt-table-cell'>Category</th>
                    <th className='tt-table-header tt-table-cell'>YTD</th>
                    <th className='tt-table-header tt-table-cell'>YTG</th>
                    <th className='tt-table-header tt-table-cell'>FY FC</th>
                    <th className='tt-table-header tt-table-cell'>FY Target</th>
                    <th className='tt-table-header tt-table-cell'>Difference</th>
                    <th className='tt-table-header tt-table-cell'>FC</th>
                    <th className='tt-table-header tt-table-cell'>Target</th>
                    <th className='tt-table-header tt-table-cell'>(Bps)</th>
                    <th className='tt-table-header tt-table-cell'>GSV</th>
                </tr>
            </thead>
            <tbody>
                {
                    tableData &&
                    tableData.map((item,ind) => (
                        <tr key={ind}>
                            <td className='tt-table-cell' style={{ textAlign: 'left' }}>{item.Category}</td>
                            <td className='tt-table-cell'>{valueConverter(item.Ytd)}</td>
                            <td className='tt-table-cell'>{valueConverter(item.Ytg)}</td>
                            <td className='tt-table-cell'>{valueConverter(item.FyFc)}</td>
                            <td className='tt-table-cell'>{valueConverter(item.FyTarget)}</td>
                            <td className='tt-table-cell'>{valueConverter(item.Difference)}</td>
                            <td className='tt-table-cell' style={{color: 'red'}}>{valueConverter(item.FC)}%</td>
                            <td className='tt-table-cell'>{valueConverter(item.Target)}%</td>
                            <td className='tt-table-cell'>{valueConverter(item.Bps)}</td>
                            <td className='tt-table-cell'>{valueConverter(item.Gsv)}</td>
                        </tr>
                    )
                    )
                }
            </tbody>
        </table>
    )
};

export default TargetYTDBrandTable;
